import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getReportsTimeline = ({ denominationId, startDate, endDate }) => {
  if (startDate && endDate) {
    return axios.get(
      `/denominations/${denominationId}/reports-timeline?start_date=${startDate}&end_date=${endDate}`
    );
  }

  return axios.get(`/denominations/${denominationId}/reports-timeline`);
};

export const useReportsTimeline = ({
  denominationId,
  startDate,
  endDate,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["reports-timeline", denominationId, startDate, endDate],
    queryFn: () => getReportsTimeline({ denominationId, startDate, endDate }),
    enabled: !!denominationId,
    select: data => data.result
  });
};
